import React from "react";
import { Lock, Check } from "lucide-react";
import { MODULES, PACKAGES, MODULE_LABEL, toList } from "@/lib/modules";
import { useAuth } from "@/lib/auth";

export function ModuleLocked({ moduleKey }) {
  const { user } = useAuth();
  return (
    <div className="max-w-lg mx-auto my-16 bg-white border border-nardo-200 rounded-xl p-8 text-center" data-testid="module-locked">
      <div className="w-14 h-14 mx-auto rounded-full bg-navy/10 flex items-center justify-center mb-4"><Lock className="w-6 h-6 text-navy" /></div>
      <h2 className="font-display font-bold text-2xl text-navy">{MODULE_LABEL[moduleKey] || "Módulo"}</h2>
      <p className="text-sm text-nardo-500 mt-2">Este módulo no está incluido en el plan de tu escuela.</p>
      <a href={`https://wa.me/525567687979?text=${encodeURIComponent(`Hola, quiero contratar el módulo "${MODULE_LABEL[moduleKey] || moduleKey}" de ZAVIA${user?.school_name ? ` para ${user.school_name}` : ""}.`)}`} target="_blank" rel="noreferrer" data-testid="module-locked-contract" className="mt-5 inline-flex items-center gap-2 bg-navy text-white px-5 py-2.5 rounded-md text-sm font-semibold">Contratar</a>
    </div>
  );
}

// Selector de módulos para el panel del propietario. value: array de claves.
export function ModulePicker({ value, onChange, testid = "modules" }) {
  const sel = new Set(toList(value));
  const toggle = (k) => { const n = new Set(sel); n.has(k) ? n.delete(k) : n.add(k); onChange(MODULES.map((m) => m.key).filter((x) => n.has(x))); };
  const groups = [...new Set(MODULES.map((m) => m.group))];
  return (
    <div className="space-y-3" data-testid={`${testid}-picker`}>
      <div className="flex flex-wrap gap-2">
        {PACKAGES.map((p) => {
          const on = p.modules.length === sel.size && p.modules.every((k) => sel.has(k));
          return <button type="button" key={p.key} data-testid={`${testid}-pkg-${p.key}`} onClick={() => onChange([...p.modules])} className={`text-xs px-3 py-1.5 rounded-full border font-semibold transition-colors ${on ? "bg-navy text-white border-navy" : "border-navy/30 text-navy hover:bg-navy/5"}`}>{p.label}</button>;
        })}
      </div>
      {groups.map((g) => (
        <div key={g}>
          <div className="text-[10px] uppercase tracking-[0.2em] text-nardo-400 mb-1">{g}</div>
          <div className="grid sm:grid-cols-2 gap-1">
            {MODULES.filter((m) => m.group === g).map((m) => (
              <button type="button" key={m.key} data-testid={`${testid}-mod-${m.key}`} onClick={() => toggle(m.key)} className={`flex items-center gap-2 text-left text-xs px-2 py-1.5 rounded-md border transition-colors ${sel.has(m.key) ? "border-emerald-300 bg-emerald-50 text-emerald-800" : "border-nardo-200 text-nardo-500"}`}>
                <span className={`w-4 h-4 rounded flex items-center justify-center ${sel.has(m.key) ? "bg-emerald-600 text-white" : "border border-nardo-300"}`}>{sel.has(m.key) && <Check className="w-3 h-3" />}</span>{m.label}
              </button>
            ))}
          </div>
        </div>
      ))}
      <div className="text-[11px] text-nardo-500">{sel.size} de {MODULES.length} módulos activos</div>
    </div>
  );
}
